import { Application } from "@hotwired/stimulus";
import CharCountController from "./char_count_controller";
import DataReportsFilterController from "./data_reports_filter_controller";
import DownloadLinkController from "./download_link_controller";
import HubAdminFormController from "./hub_admin_form_controller";
import HubCompanySearchController from "./hub_company_search_controller";
import HubContactMessageController from "./hub_contact_message_controller";
import HubFilesFormController from "./hub_files_form_controller";
import HubInstructionsController from "./hub_instructions_controller";
import HubStaffContactFormController from "./hub_staff_contact_form_controller";
import StaffContactsFilterController from "./staff_contacts_filter_controller";

const application = Application.start();
application.register("char-count", CharCountController);
application.register("data-reports-filter", DataReportsFilterController);
application.register("download-link", DownloadLinkController);
application.register("hub-contact-message", HubContactMessageController);
application.register("hub-instructions", HubInstructionsController);
application.register("hub-files-form", HubFilesFormController);
application.register("hub-admin-form", HubAdminFormController);
application.register("hub-company-search", HubCompanySearchController);
application.register("staff-contacts-filter", StaffContactsFilterController);
application.register("hub-staff-contact-form", HubStaffContactFormController);
